import {AnimationBaseController, IAnimationControllerConfiguration, Inject} from "@denishussar/html5-game-engine";
import {SendLetterLogic} from "../Logic/SendLetterLogic";
import {LetterModel, LetterStateEnum} from "../Models/LetterModel";

export interface ILetterControllerOptions {
}

export class LetterController extends AnimationBaseController {

    $model: LetterModel;

    public constructor(@Inject private _options: ILetterControllerOptions,
                       @Inject private _gameLogic: SendLetterLogic) {
        super("LetterAnimationController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return {
            childControllers: {},
            modelWatch: {
                "state": (newValue: LetterStateEnum, oldValue: LetterStateEnum) => this.gotoAndStop(`${LetterStateEnum[this.$model.state]}`)
            }
        };
    }

    protected onInitialize(): void {}

    protected onAnimationEvent(name: string, ...args): void {}
}
